export default "__VITE_ASSET__DiTAk_na__"